<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="deleteAcademiaAutoresponder"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionAcademyAutorespondersModalDelete.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <p>
          {{ $t('mEditionAcademyAutorespondersModalDelete.messageDelete.element') }}
          <b>{{ $modal.element.descripcion }}</b>
          {{ $t('mEditionAcademyAutorespondersModalDelete.messageDelete.options') }}
        </p>
        <small class="text-color-danger">
            {{ $t('mFeedAssetsContentModalDelete.messageDelete.notReversed') }}
        </small>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionAcademyAutorespondersModalDelete.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionAcademyAutorespondersModalDelete',

  data () {
    return {
      academiaId: '',

      buttonPrimary: {
        action: this.$t('mEditionAcademyAutorespondersModalDelete.buttonPrimary'),
        behavior: 'delete',
        class: 'a-button-danger-primary',
        sending: false,
        type: 'submit'
      }
    }
  },

  created () {
    this.academiaId = this.$store.getters.getAcademyData.id
  },

  methods: {
    deleteAcademiaAutoresponder (autoresponderId) {
      if (!this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.delete('academia', 'deleteAcademiaAutoresponder', {}, [this.academiaId, this.$modal.element.id_academia_autoresponder])
          .then(response => {
            this.$modal.updateData()
            this.$modal.closeModal()
            this.$alerts.pushAlert('mEditionAcademyAutorespondersModalDelete', 'deleteAcademiaAutoresponder', 'success')
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionAcademyAutorespondersModalDelete', 'deleteAcademiaAutoresponder', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
